export default class RepController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$uibModal,
		registresService,
		PaginationService,
		notification,
		$translate,
		moment,
		ModalService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.moment = moment;
		this.ModalService = ModalService;
		this.registresService = registresService;
		this.PaginationService = PaginationService;
    }
}